import { gql } from '@apollo/client';

export const ChargePaymentMethod = gql`
    mutation chargePaymentMethod($paymentMethodId: String!, $amount: Float!) {
        chargePaymentMethod(paymentMethodId: $paymentMethodId, amount: $amount) {
            ... on GenericSuccessType {
                message
                successVars {
                    key
                    value
                }
            }
            ... on GenericErrorType {
                message
                errorVars {
                    key
                    value
                }
            }
        }
    }
`;

export const AddMinutesQl = gql`
    mutation addMinutesToUser($minutes: Int!, $paymentIntentId: String!) {
        addMinutesToUser(paymentIntentId: $paymentIntentId, minutes: $minutes) {
            ... on SuccessType {
                message
            }
            ... on ErrorType {
                message
            }
        }
    }
`;
